module.exports = __webpack_public_path__ + "static/media/LogoDQInstitute.8f1df0fc.png";